// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectReportType_root__3s41H","wizardCard":"SelectReportType_wizardCard__1uKjb"};